


// import { useRef } from 'react';
// import { Link } from 'react-router-dom';
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { useGSAP } from '@gsap/react';
// import BackgroundVisuals from "../components/BackgroundVisuals";

// gsap.registerPlugin(ScrollTrigger);

// const products = [
//   {
//     name: 'Retail',
//     path: '/products/retail',
//     tagline: 'AI-powered intelligence for modern retail',
//     desc: 'Transform customer experiences, optimize inventory, and drive revenue with neural architectures built specifically for retail operations.',
//     accent: '#952877',
//     features: ['Demand Forecasting', 'Personalization Engine', 'Price Optimization'],
//     overview: 'Purpose-built AI for the modern retail ecosystem — from shelf to checkout, from warehouse to last-mile delivery.',
//     icon: (
//       <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-1.5 6h13M10 19a1 1 0 100 2 1 1 0 000-2zm7 0a1 1 0 100 2 1 1 0 000-2z" />
//       </svg>
//     ),
//   },
//   {
//     name: 'Manufacturing',
//     path: '/products/manufacturing',
//     tagline: 'Intelligent automation for the factory floor',
//     desc: 'Predictive maintenance, AI quality control, and supply chain optimization that keep production lines running at peak efficiency.',
//     accent: '#592aa7',
//     features: ['Predictive Maintenance', 'Visual Quality Control', 'Supply Chain AI'],
//     overview: 'Deep industrial intelligence that keeps machines running, quality high, and supply chains optimized end-to-end.',
//     icon: (
//       <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
//       </svg>
//     ),
//   },
//   {
//     name: 'Transport',
//     path: '/products/transport',
//     tagline: 'Smarter movement through AI logistics',
//     desc: 'Route optimization, fleet intelligence, and real-time logistics analytics that move people and goods faster, safer, and cheaper.',
//     accent: '#17091a',
//     features: ['Route Optimization', 'Fleet Intelligence', 'Logistics Analytics'],
//     overview: 'Real-time intelligence for fleets, routes, and logistics networks — built to move the world more efficiently.',
//     icon: (
//       <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
//         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10l2 1h8zM13 8h4l3 5v3h-2m-5-8v8" />
//       </svg>
//     ),
//   },
// ];

// const whyViconAI = [
//   'Purpose-built vertical AI — not generic models',
//   'Deployable in weeks, not months',
//   'Measurable ROI from day one',
//   'Seamless integration with existing systems',
//   'Continuous model improvement post-launch',
//   'Dedicated AI engineers, not consultants',
// ];

// const ProductsPage = () => {
//   const headerRef = useRef(null);
//   const cardsRef = useRef(null);

//   useGSAP(() => {
//     // Hero animation
//     gsap.fromTo(
//       headerRef.current.querySelectorAll('.hero-anim'),
//       { y: 40, opacity: 0 },
//       { y: 0, opacity: 1, duration: 0.6, ease: 'power2.out', stagger: 0.1, delay: 0.1 }
//     );

//     // Cards scroll animation
//     gsap.fromTo(
//       cardsRef.current.querySelectorAll('.product-card'),
//       { y: 50, opacity: 0 },
//       {
//         y: 0,
//         opacity: 1,
//         duration: 0.5,
//         ease: 'power2.out',
//         stagger: 0.15,
//         scrollTrigger: {
//           trigger: cardsRef.current,
//           start: 'top 80%',
//           toggleActions: 'play none none reverse',
//         },
//       }
//     );
//   }, []);

//   return (
//     <div className="min-h-screen bg-white text-[#17091a] selection:bg-[#952877]/10 selection:text-[#952877]">
//       <BackgroundVisuals />

//       {/* --- HERO --- */}
//       <section ref={headerRef} className="pt-40 pb-24 relative z-10 px-6 overflow-hidden">
//         <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#952877]/5 blur-[120px] rounded-full pointer-events-none"></div>
//         <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#592aa7]/5 blur-[100px] rounded-full pointer-events-none"></div>

//         <div className="max-w-6xl mx-auto text-center">
         
//           <h1 className="hero-anim text-5xl md:text-8xl font-black text-[#17091a] mb-8 tracking-tighter leading-[1.1]">
//             AI Built{' '}
//             <span className="bg-gradient-to-r from-[#952877] to-[#592aa7] bg-clip-text text-transparent ">
//               For Your
//             </span>{' '}
//             Industry
//           </h1>
//           <p className="hero-anim text-xl md:text-2xl text-gray-500 max-w-3xl mx-auto leading-relaxed font-light">
//             Purpose-built neural architectures for retail, manufacturing, and transport — not generic AI, but deep vertical intelligence that ships fast and scales further.
//           </p>
//         </div>
//       </section>

//       <div className="relative z-10 space-y-32 pb-32">

//         {/* --- PRODUCT CARDS --- */}
//         <section ref={cardsRef} className="max-w-7xl mx-auto px-6 mt-5">
//           <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
//             <div className="max-w-xl">
//               <h2 className="text-xs font-black uppercase tracking-[0.4em] text-[#952877] mb-4">Product Suite</h2>
//               <h3 className="text-4xl md:text-6xl font-black text-[#17091a] tracking-tighter">
//                 Choose Your <span className="italic font-light">Vertical</span>
//               </h3>
//             </div>
//             <p className="text-gray-400 font-medium italic max-w-xs text-right">
//               Each product is a standalone AI platform — deeply specialized, immediately deployable.
//             </p>
//           </div>

//           <div className="grid lg:grid-cols-3 gap-8">
//             {products.map((product, index) => (
//               <Link
//                 key={product.path}
//                 to={product.path}
//                 className="product-card group bg-white/40 backdrop-blur-xl rounded-[2.5rem] border border-gray-100 p-10 hover:border-[#952877]/30 transition-all duration-700 shadow-[0_20px_50px_-15px_rgba(0,0,0,0.03)] hover:shadow-[0_40px_80px_-20px_rgba(149,40,119,0.1)] relative overflow-hidden flex flex-col"
//               >
//                 {/* Hover glow */}
//                 <div
//                   className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-[2.5rem]"
//                   style={{ background: `radial-gradient(circle at top left, ${product.accent}08, transparent 60%)` }}
//                 ></div>

//                 {/* Stage tag */}
//                 <div className="mb-8">
                 
//                 </div>

//                 {/* Icon */}
//                 <div
//                   className="w-16 h-16 rounded-2xl flex items-center justify-center mb-7 transition-transform duration-300 group-hover:scale-110"
//                   style={{ background: `${product.accent}12`, color: product.accent }}
//                 >
//                   {product.icon}
//                 </div>

//                 {/* Tagline */}
//                 <p
//                   className="text-[10px] font-black tracking-[0.15em] uppercase mb-3"
//                   style={{ color: product.accent }}
//                 >
//                   {product.tagline}
//                 </p>

//                 {/* Name */}
//                 <h3 className="text-2xl md:text-3xl font-black text-[#17091a] mb-4 tracking-tight group-hover:text-[#952877] transition-colors duration-300">
//                   {product.name}
//                 </h3>

//                 {/* Overview */}
//                 <p className="text-gray-500 text-sm leading-relaxed mb-8 flex-grow">{product.overview}</p>

//                 <div className="h-px bg-gray-100 w-full mb-8"></div>

//                 {/* Features */}
//                 <ul className="space-y-4 mb-8">
//                   {product.features.map((f) => (
//                     <li key={f} className="flex items-center text-[11px] font-bold uppercase tracking-widest text-gray-600">
//                       <span
//                         className="w-1.5 h-1.5 rounded-full mr-4 shadow-[0_0_8px_rgba(149,40,119,0.4)] flex-shrink-0"
//                         style={{ background: product.accent }}
//                       ></span>
//                       {f}
//                     </li>
//                   ))}
//                 </ul>

//                 {/* CTA arrow */}
//                 <div
//                   className="flex items-center gap-2 font-black text-[11px] uppercase tracking-widest"
//                   style={{ color: product.accent }}
//                 >
//                   Explore {product.name}
//                   <svg
//                     className="w-4 h-4 group-hover:translate-x-1 transition-transform"
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
//                   </svg>
//                 </div>

//                 {/* Bottom bar */}
//                 <div className="absolute bottom-0 left-0 w-full h-1 bg-gray-100">
//                   <div
//                     className="h-full transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"
//                     style={{ background: `linear-gradient(to right, ${product.accent}, #592aa7)` }}
//                   ></div>
//                 </div>
//               </Link>
//             ))}
//           </div>
//         </section>

//         {/* --- WHY VICONAI (Dark Section) --- */}
//         <section className="py-32 bg-[#17091a] rounded-[4rem] text-white overflow-hidden relative mx-6">
//           <div className="absolute top-0 right-0 w-96 h-96 bg-[#952877]/10 blur-[100px] rounded-full pointer-events-none"></div>
//           <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#592aa7]/10 blur-[80px] rounded-full pointer-events-none"></div>

//           <div className="max-w-7xl mx-auto px-6 relative z-10">
//             <div className="grid lg:grid-cols-12 gap-20 items-center">
//               <div className="lg:col-span-5">
//                 <h2 className="text-xs font-black uppercase tracking-[0.4em] text-[#952877] mb-6">
//                   Strategic Value
//                 </h2>
//                 <h3 className="text-4xl md:text-6xl font-black tracking-tighter leading-none mb-10 text-white">
//                   Why Partner <br /> With{' '}
//                   <span className="italic text-[#952877]">ViconAI?</span>
//                 </h3>
//                 <p className="text-gray-400 text-lg leading-relaxed mb-10 font-medium">
//                   We deliver measurable business impact. Our vertical products are designed to scale, adapt, and provide long-term proprietary value with zero generic bloat.
//                 </p>
//                 <Link
//                   to="/contact"
//                   className="inline-flex h-14 items-center px-10 bg-[#952877] text-white text-[10px] font-black uppercase tracking-widest rounded-xl hover:bg-white hover:text-[#17091a] transition-all shadow-[0_10px_20px_rgba(149,40,119,0.2)]"
//                 >
//                   Request Technical Brief
//                 </Link>
//               </div>

//               <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
//                 {whyViconAI.map((point, index) => (
//                   <div
//                     key={index}
//                     className="p-8 rounded-[2rem] bg-white/5 border border-white/10 flex flex-col justify-between hover:bg-white/10 transition-all group"
//                   >
//                     <div className="w-10 h-10 rounded-xl bg-[#952877] flex items-center justify-center text-white mb-6 group-hover:scale-110 transition-transform">
//                       <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
//                       </svg>
//                     </div>
//                     <span className="text-white font-black text-sm uppercase tracking-tight">{point}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* --- INDUSTRIES SERVED --- */}
//         <section className="max-w-7xl mx-auto px-6">
//           <div className="grid md:grid-cols-2 gap-10">

//             {/* Sectors */}
//             <div className="bg-[#fafafa] border border-gray-100 rounded-[3rem] p-12 shadow-sm">
//               <h3 className="text-xl font-black uppercase tracking-[0.3em] text-[#952877] mb-12 flex items-center">
//                 <span className="w-8 h-px bg-[#952877] mr-4"></span>
//                 Sectors Served
//               </h3>
//               <div className="flex flex-wrap gap-3">
//                 {['Retail & E-Commerce', 'Automotive Manufacturing', 'Logistics & Freight', 'FMCG', 'Industrial Manufacturing', 'Public Transport', 'Fashion Retail', 'Heavy Industry'].map((sector, i) => (
//                   <span
//                     key={i}
//                     className="px-6 py-3 rounded-full bg-white border border-gray-100 text-gray-500 font-bold text-[10px] uppercase tracking-widest hover:bg-[#17091a] hover:text-white hover:border-[#17091a] transition-all cursor-default"
//                   >
//                     {sector}
//                   </span>
//                 ))}
//               </div>
//             </div>

//             {/* Deployment stats */}
//             <div className="bg-white border border-gray-100 rounded-[3rem] p-12 relative overflow-hidden shadow-sm">
//               <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#592aa7]/5 blur-[80px] rounded-full pointer-events-none"></div>
//               <h3 className="text-xl font-black uppercase tracking-[0.3em] text-[#17091a] mb-12 flex items-center">
//                 <span className="w-8 h-px bg-gray-200 mr-4"></span>
//                 Deployment Profile
//               </h3>
//               <div className="grid grid-cols-2 gap-6 relative z-10">
//                 {[
//                   { label: 'Avg. Deploy Time', value: '6 Weeks' },
//                   { label: 'Model Accuracy', value: '97.4%' },
//                   { label: 'ROI Timeline', value: '90 Days' },
//                   { label: 'Uptime SLA', value: '99.9%' },
//                 ].map((stat, i) => (
//                   <div key={i} className="p-6 rounded-2xl bg-gray-50 border border-gray-100">
//                     <p className="text-[10px] font-black uppercase tracking-widest text-gray-400 mb-2">{stat.label}</p>
//                     <p className="text-2xl font-black text-[#17091a]">{stat.value}</p>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </section>

//         {/* --- FINAL CTA --- */}
//         <section className="max-w-7xl mx-auto px-6">
//           <div className="bg-[#17091a] rounded-[4rem] p-12 md:p-24 text-center border border-gray-100 relative overflow-hidden shadow-2xl">
//             <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top_right,rgba(149,40,119,0.15),transparent_70%)] pointer-events-none"></div>
//             <div className="relative z-10 max-w-3xl mx-auto">
//               <h2 className="text-4xl md:text-7xl font-black mb-10 tracking-tighter leading-tight text-white">
//                 Ready to <span className="text-[#952877] italic">Deploy?</span>
//               </h2>
//               <p className="text-gray-400 text-lg mb-10 font-light">
//                 Tell us your industry and we'll show you exactly what AI can do for you — in a free 30-minute technical brief.
//               </p>
//               <div className="flex flex-col sm:flex-row gap-6 justify-center">
//                 <Link
//                   to="/contact"
//                   className="px-12 py-6 bg-[#952877] text-white font-black text-xs uppercase tracking-[0.3em] rounded-2xl shadow-[0_20px_40px_rgba(149,40,119,0.3)] hover:-translate-y-2 transition-all duration-500"
//                 >
//                   Initialize Project
//                 </Link>
//                 <Link
//                   to="/"
//                   className="px-12 py-6 border border-white/10 text-white font-black text-xs uppercase tracking-[0.3em] rounded-2xl hover:bg-white/10 transition-all"
//                 >
//                   Back to Home
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>
//     </div>
//   );
// };

// export default ProductsPage;


import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';
import BackgroundVisuals from "../components/BackgroundVisuals";

gsap.registerPlugin(ScrollTrigger);

const products = [
  {
    name: 'Retail',
    path: '/products/retail',
    tagline: 'Directional Intelligence & Customer Analytics',
    desc: 'Direction Detection ON (DDON) and real-time gaze & movement tracking to unlock critical pre-footfall consumer insights.',
    accent: '#952877',
    features: [
      'Direction Detection ON (DDON)',
      'Customer Direction & Gaze Analytics',
      'Attention Duration & Focus Mapping',
      'Pre-Footfall Consumer Intelligence'
    ],
    overview: 'Advanced visual analytics identifying where customers look and for how long — delivering high-precision intelligence before footfall conversion.',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
    ),
  },
  {
    name: 'Manufacturing',
    path: '/products/manufacturing',
    tagline: 'Vision AI for Factory & Yard Operations',
    desc: 'Automated vehicle gate entries, dispatch verification, worker safety compliance, and pose tracking powered by industrial Vision AI.',
    accent: '#592aa7',
    features: [
      'Automated Gate Entry & Touchpoint Tracking',
      'Bay & Weighbridge Routing (SAP Integrated)',
      'Vision AI Automated Dispatch & Duplicates',
      'People Movement, Pose & PPE Compliance'
    ],
    overview: 'End-to-end yard and shopfloor intelligence: automated vehicle logging with predictive durations, duplicate dispatch elimination, and worker PPE compliance.',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
  },
  {
    name: 'Mobility',
    path: '/products/transport',
    tagline: 'Autonomous Safety, Road Defect & Traffic AI',
    desc: 'Next-generation ADAS Level 2 vision, zero-infrastructure floating enforcement, and sub-surface road defect detection.',
    accent: '#17091a',
    features: [
      'Vision AI ADAS L2 (Safe Distance & Collision)',
      'Road Sign Board Interpretation',
      'INTACRO — Road Defect Early Warning',
      'Floating Cop: Speed, Lane & Parking Violations'
    ],
    overview: 'Comprehensive road mobility: L2 ADAS driver assistance, INTACRO defect detection beyond human vision, and camera-free Floating Cop violation tracking.',
    icon: (
      <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10l2 1h8zM13 8h4l3 5v3h-2m-5-8v8" />
      </svg>
    ),
  },
];

const whyViconAI = [
  'Purpose-built vertical AI — not generic models',
  'Seamless SAP & industrial ERP integrations',
  'Camera & infrastructure-free Floating Cop options',
  'Vision beyond human, camera & radar limits (INTACRO)',
  'Continuous real-time edge & cloud model improvement',
  'Dedicated AI engineers with deep domain expertise',
];

const ProductsPage = () => {
  const headerRef = useRef(null);
  const cardsRef = useRef(null);

  useGSAP(() => {
    // Hero animation
    gsap.fromTo(
      headerRef.current.querySelectorAll('.hero-anim'),
      { y: 40, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.6, ease: 'power2.out', stagger: 0.1, delay: 0.1 }
    );

    // Cards scroll animation
    gsap.fromTo(
      cardsRef.current.querySelectorAll('.product-card'),
      { y: 50, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 0.5,
        ease: 'power2.out',
        stagger: 0.15,
        scrollTrigger: {
          trigger: cardsRef.current,
          start: 'top 80%',
          toggleActions: 'play none none reverse',
        },
      }
    );
  }, []);

  return (
    <div className="min-h-screen bg-white text-[#17091a] selection:bg-[#952877]/10 selection:text-[#952877]">
      <BackgroundVisuals />

      {/* --- HERO --- */}
      <section ref={headerRef} className="pt-40 pb-24 relative z-10 px-6 overflow-hidden">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#952877]/5 blur-[120px] rounded-full pointer-events-none"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#592aa7]/5 blur-[100px] rounded-full pointer-events-none"></div>

        <div className="max-w-6xl mx-auto text-center">
          <h1 className="hero-anim text-5xl md:text-8xl font-black text-[#17091a] mb-8 tracking-tighter leading-[1.1]">
            AI Built{' '}
            <span className="bg-gradient-to-r from-[#952877] to-[#592aa7] bg-clip-text text-transparent ">
              For Your
            </span>{' '}
            Industry
          </h1>
          <p className="hero-anim text-xl md:text-2xl text-gray-500 max-w-3xl mx-auto leading-relaxed font-light">
            Purpose-built Vision AI architectures for retail analytics, automated manufacturing operations, and next-generation mobility solutions.
          </p>
        </div>
      </section>

      <div className="relative z-10 space-y-32 pb-32">

        {/* --- PRODUCT CARDS --- */}
        <section ref={cardsRef} className="max-w-7xl mx-auto px-6 mt-5">
          <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
            <div className="max-w-xl">
              <h2 className="text-xs font-black uppercase tracking-[0.4em] text-[#952877] mb-4">Product Suite</h2>
              <h3 className="text-4xl md:text-6xl font-black text-[#17091a] tracking-tighter">
                Choose Your <span className="italic font-light">Vertical</span>
              </h3>
            </div>
            <p className="text-gray-400 font-medium italic max-w-xs text-right">
              Specialized Vision AI platforms engineered for mission-critical deployments.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8">
            {products.map((product) => (
              <Link
                key={product.path}
                to={product.path}
                className="product-card group bg-white/40 backdrop-blur-xl rounded-[2.5rem] border border-gray-100 p-10 hover:border-[#952877]/30 transition-all duration-700 shadow-[0_20px_50px_-15px_rgba(0,0,0,0.03)] hover:shadow-[0_40px_80px_-20px_rgba(149,40,119,0.1)] relative overflow-hidden flex flex-col"
              >
                {/* Hover glow */}
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-[2.5rem]"
                  style={{ background: `radial-gradient(circle at top left, ${product.accent}08, transparent 60%)` }}
                ></div>

                {/* Icon */}
                <div
                  className="w-16 h-16 rounded-2xl flex items-center justify-center mb-7 transition-transform duration-300 group-hover:scale-110"
                  style={{ background: `${product.accent}12`, color: product.accent }}
                >
                  {product.icon}
                </div>

                {/* Tagline */}
                <p
                  className="text-[10px] font-black tracking-[0.15em] uppercase mb-3"
                  style={{ color: product.accent }}
                >
                  {product.tagline}
                </p>

                {/* Name */}
                <h3 className="text-2xl md:text-3xl font-black text-[#17091a] mb-4 tracking-tight group-hover:text-[#952877] transition-colors duration-300">
                  {product.name}
                </h3>

                {/* Overview */}
                <p className="text-gray-500 text-sm leading-relaxed mb-8 flex-grow">{product.overview}</p>

                <div className="h-px bg-gray-100 w-full mb-8"></div>

                {/* Features */}
                <ul className="space-y-4 mb-8">
                  {product.features.map((f) => (
                    <li key={f} className="flex items-start text-[11px] font-bold uppercase tracking-widest text-gray-600">
                      <span
                        className="w-1.5 h-1.5 rounded-full mr-3 mt-1 shadow-[0_0_8px_rgba(149,40,119,0.4)] flex-shrink-0"
                        style={{ background: product.accent }}
                      ></span>
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>

                {/* CTA arrow */}
                <div
                  className="flex items-center gap-2 font-black text-[11px] uppercase tracking-widest mt-auto"
                  style={{ color: product.accent }}
                >
                  Explore {product.name}
                  <svg
                    className="w-4 h-4 group-hover:translate-x-1 transition-transform"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </div>

                {/* Bottom bar */}
                <div className="absolute bottom-0 left-0 w-full h-1 bg-gray-100">
                  <div
                    className="h-full transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"
                    style={{ background: `linear-gradient(to right, ${product.accent}, #592aa7)` }}
                  ></div>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* --- WHY VICONAI (Dark Section) --- */}
        <section className="py-32 bg-[#17091a] rounded-[4rem] text-white overflow-hidden relative mx-6">
          <div className="absolute top-0 right-0 w-96 h-96 bg-[#952877]/10 blur-[100px] rounded-full pointer-events-none"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#592aa7]/10 blur-[80px] rounded-full pointer-events-none"></div>

          <div className="max-w-7xl mx-auto px-6 relative z-10">
            <div className="grid lg:grid-cols-12 gap-20 items-center">
              <div className="lg:col-span-5">
                <h2 className="text-xs font-black uppercase tracking-[0.4em] text-[#952877] mb-6">
                  Strategic Value
                </h2>
                <h3 className="text-4xl md:text-6xl font-black tracking-tighter leading-none mb-10 text-white">
                  Why Partner <br /> With{' '}
                  <span className="italic text-[#952877]">ViconAI?</span>
                </h3>
                <p className="text-gray-400 text-lg leading-relaxed mb-10 font-medium">
                  We engineer computer vision solutions that bridge the gap between physical real-world events and digital decision systems like SAP with speed, accuracy, and zero infrastructure bloat.
                </p>
                <Link
                  to="/contact"
                  className="inline-flex h-14 items-center px-10 bg-[#952877] text-white text-[10px] font-black uppercase tracking-widest rounded-xl hover:bg-white hover:text-[#17091a] transition-all shadow-[0_10px_20px_rgba(149,40,119,0.2)]"
                >
                  Request Technical Brief
                </Link>
              </div>

              <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
                {whyViconAI.map((point, index) => (
                  <div
                    key={index}
                    className="p-8 rounded-[2rem] bg-white/5 border border-white/10 flex flex-col justify-between hover:bg-white/10 transition-all group"
                  >
                    <div className="w-10 h-10 rounded-xl bg-[#952877] flex items-center justify-center text-white mb-6 group-hover:scale-110 transition-transform">
                      <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="text-white font-black text-sm uppercase tracking-tight">{point}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* --- INDUSTRIES SERVED --- */}
        <section className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-10">

            {/* Sectors */}
            <div className="bg-[#fafafa] border border-gray-100 rounded-[3rem] p-12 shadow-sm">
              <h3 className="text-xl font-black uppercase tracking-[0.3em] text-[#952877] mb-12 flex items-center">
                <span className="w-8 h-px bg-[#952877] mr-4"></span>
                Key Focus Domains
              </h3>
              <div className="flex flex-wrap gap-3">
                {[
                  'Customer Analytics & Retail',
                  'Factory Yard Management',
                  'Automated Dispatch & Weighbridges',
                  'Workplace Safety & PPE',
                  'Autonomous ADAS L2 Mobility',
                  'Road Infrastructure & INTACRO',
                  'Floating Traffic Enforcement',
                  'Enterprise SAP Logistics'
                ].map((sector, i) => (
                  <span
                    key={i}
                    className="px-6 py-3 rounded-full bg-white border border-gray-100 text-gray-500 font-bold text-[10px] uppercase tracking-widest hover:bg-[#17091a] hover:text-white hover:border-[#17091a] transition-all cursor-default"
                  >
                    {sector}
                  </span>
                ))}
              </div>
            </div>

            {/* Deployment stats */}
            <div className="bg-white border border-gray-100 rounded-[3rem] p-12 relative overflow-hidden shadow-sm">
              <div className="absolute bottom-0 right-0 w-64 h-64 bg-[#592aa7]/5 blur-[80px] rounded-full pointer-events-none"></div>
              <h3 className="text-xl font-black uppercase tracking-[0.3em] text-[#17091a] mb-12 flex items-center">
                <span className="w-8 h-px bg-gray-200 mr-4"></span>
                Deployment Profile
              </h3>
              <div className="grid grid-cols-2 gap-6 relative z-10">
                {[
                  { label: 'Vision AI Precision', value: '99.2%' },
                  { label: 'Integration Layer', value: 'Direct SAP' },
                  { label: 'Detection Latency', value: '< 20ms' },
                  { label: 'Uptime SLA', value: '99.9%' },
                ].map((stat, i) => (
                  <div key={i} className="p-6 rounded-2xl bg-gray-50 border border-gray-100">
                    <p className="text-[10px] font-black uppercase tracking-widest text-gray-400 mb-2">{stat.label}</p>
                    <p className="text-2xl font-black text-[#17091a]">{stat.value}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* --- FINAL CTA --- */}
        <section className="max-w-7xl mx-auto px-6">
          <div className="bg-[#17091a] rounded-[4rem] p-12 md:p-24 text-center border border-gray-100 relative overflow-hidden shadow-2xl">
            <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_top_right,rgba(149,40,119,0.15),transparent_70%)] pointer-events-none"></div>
            <div className="relative z-10 max-w-3xl mx-auto">
              <h2 className="text-4xl md:text-7xl font-black mb-10 tracking-tighter leading-tight text-white">
                Ready to <span className="text-[#952877] italic">Deploy?</span>
              </h2>
              <p className="text-gray-400 text-lg mb-10 font-light">
                Tell us your operational goals and we'll show you how our Vision AI solutions integrate into your workflow in a free 30-minute technical brief.
              </p>
              <div className="flex flex-col sm:flex-row gap-6 justify-center">
                <Link
                  to="/contact"
                  className="px-12 py-6 bg-[#952877] text-white font-black text-xs uppercase tracking-[0.3em] rounded-2xl shadow-[0_20px_40px_rgba(149,40,119,0.3)] hover:-translate-y-2 transition-all duration-500"
                >
                  Initialize Project
                </Link>
                <Link
                  to="/"
                  className="px-12 py-6 border border-white/10 text-white font-black text-xs uppercase tracking-[0.3em] rounded-2xl hover:bg-white/10 transition-all"
                >
                  Back to Home
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ProductsPage;